import { articles } from "@/mocks/gossip";
import ArticleCard from "@/components/base/ArticleCard";
import SectionHeading from "@/components/base/SectionHeading";

const latest = [...articles].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 6);
const leftColumn = latest.slice(0, 3);
const rightColumn = latest.slice(3, 6);

export default function LatestSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100" aria-labelledby="latest-heading">
      <SectionHeading
        kicker="Latest Feed"
        title="最新猛料速览"
        desc="按更新时间倒序排列。每条都保持简短摘要，先看结论，再决定要不要点进去读完整整理。"
      />
      <h2 id="latest-heading" className="sr-only">
        最新猛料速览
      </h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-0">
        <div>
          {leftColumn.map((item) => (
            <ArticleCard key={item.id} article={item} variant="compact" />
          ))}
        </div>
        <div>
          {rightColumn.map((item) => (
            <ArticleCard key={item.id} article={item} variant="compact" />
          ))}
        </div>
      </div>
    </section>
  );
}